import { gql } from "apollo-boost";

export const FrOrganizers = gql`
  query frOrganizers($orgId: String!) {
    frOrganizers(orgId: $orgId) {
      id
      name
      admins {
        id
        name
      }
    }
  }
`;

export const addFrOrganizerAdmin = gql`
  mutation addFrOrganizerAdmin($input: FrOrganizerMemberInput!) {
    addFrOrganizerAdmin(input: $input) {
      id
      name
    }
  }
`;

export const delFrOrganizerAdmin = gql`
  mutation delFrOrganizerAdmin($input: FrOrganizerMemberInput!) {
    delFrOrganizerAdmin(input: $input) {
      id
      name
    }
  }
`;

export const frGql = {
  addFrOrganizerAdmin,
  delFrOrganizerAdmin,
};
